import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from "react";
import { MutableRefObject } from "react";
import { Heading2, Heading3, Text } from "../components/blog/parts";
import { slugify } from "../services/slugify";

export const useContentful = () => {
    const getOptions = (
        pageOverviewRef?: MutableRefObject<HTMLUListElement>,
        headingsRef?: MutableRefObject<string[]>
    ) => {
        if (headingsRef) headingsRef.current = [];
        return {
            renderMark: {},
            renderNode: {
                [INLINES.HYPERLINK]: (node, children) => (
                    <Link to={`/${node.data.uri}`} className="app-href">
                        {children}
                    </Link>
                ),
                [INLINES.EMBEDDED_ENTRY]: (node, children) => (
                    <Link
                        className="app-href"
                        to={`/${
                            node.data.target.resort?.slug ||
                            node.data.target.region?.slug.replace(
                                "{month}",
                                "climate"
                            ) + "/"
                        }`}
                    >
                        {node.data.target.text}
                    </Link>
                ),
                [BLOCKS.HEADING_2]: (_, children) => {
                    const name = children[0]?.props?.children || children[0];
                    if (!name) {
                        return;
                    }
                    if (headingsRef) {
                        headingsRef.current.push(name);
                    }
                    return <Heading2 id={slugify(name)}>{children}</Heading2>;
                },
                [BLOCKS.HEADING_3]: (_, children) => {
                    return <Heading3>{children}</Heading3>;
                },
                [BLOCKS.PARAGRAPH]: (_, children) => {
                    if (
                        children.length == 0 ||
                        (children.length == 1 && !children[0])
                    )
                        return null;
                    return <Text>{children}</Text>;
                },
                [BLOCKS.EMBEDDED_ENTRY]: (node) => {
                    switch (node.data.target.__typename) {
                        case "ContentfulPageOverview":
                            // TODO locale
                            return null;
                        case "ContentfulMapSearch":
                            return null;
                        // dispatch(
                        //     setValuesBeforeInit({
                        //         month: month,
                        //         continent: node.data.target.continent?.slug
                        //     })
                        // );
                        // // TODO locale
                        // return (
                        //     <>
                        //         <Text>
                        //             Here you can find destinations with the
                        //             desired weather:
                        //         </Text>
                        //         <WeatherSearchForm className="mt-8 mb-12" />
                        //     </>
                        // );
                    }
                },
                [BLOCKS.EMBEDDED_ASSET]: (node) => {
                    return (
                        <div className="my-10 mx-auto block w-11/12 max-w-[660px]">
                            <GatsbyImage
                                className="rounded-md"
                                image={getImage(
                                    node.data.target.localFile.childImageSharp
                                        .gatsbyImageData
                                )}
                                alt={node.data.target.description}
                            />
                        </div>
                    );
                }
            }
        };
    };
    return {
        getOptions
    };
};
